import { SearchObject } from './Models';
import { useTheme } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';

interface IHighlightProps {
  attribute: string;
  hit: SearchObject;
}

const Highlight: React.FC<IHighlightProps> = (props) => {
  const theme = useTheme();
  const { attribute, hit } = props;

  const getValue = (obj: any, path: string) => {
    const normalizedPath = path.replace(/\[(\d+)\]/g, '.$1');
    return normalizedPath.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  };

  const parsedHit = [
    {
      value: String(getValue(hit, attribute) ?? ''),
      isHighlighted: false
    }
  ];

  return (
    <Fragment>
      {parsedHit.map((part, index) =>
        part.isHighlighted ? (
          <mark key={index} style={{ backgroundColor: theme.palette.grey[100] }}>
            {part.value}
          </mark>
        ) : (
          <span key={index}>{part.value}</span>
        )
      )}
    </Fragment>
  );
};

export default Highlight;
